import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Container, Row, Col, Spinner, Badge } from 'react-bootstrap';
import PageTitle from '../../common/PageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { apiLoadUser, apiUpdateUser, apiUpdatePassword } from '../../../api/api';
import { useUser } from '../../../context/UserContext';
import { useToast } from '../../../context/ToastContext';
import braUfCities from '../../../assets/json/braUfCities.json';
import { PROFILE_ROOT, PROFILE_ROOT_ID, PROFILE_ADMIN_ID } from '../../../Consts';

const Profile = () => {
  const { user } = useUser();
  const { addToast } = useToast();
  const { userId } = useParams();
  const navigate = useNavigate();

  const [dbUserId, setDbUserId] = useState(null);
  const [dbUser, setDbUser] = useState(null);

  const [selectedName, setSelectedName] = useState('');
  const [selectedEmail, setSelectedEmail] = useState('');
  const [selectedMobile, setSelectedMobile] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedSubscription, setSelectedSubscription] = useState('');
  const [selectedReleasedDeadline, setSelectedReleasedDeadline] = useState('');
  const [selectedSearches, setSelectedSearches] = useState('');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [cities, setCities] = useState([]);
  const [loadingUser, setLoadingUser] = useState(false);
  const [loadingPass, setLoadingPass] = useState(false);


  useEffect(() => {
    if (!user) {
      addToast('Usuário não autenticado');
      return;
    }
    if (user.profile !== PROFILE_ROOT_ID && user.profile !== PROFILE_ADMIN_ID) {
      addToast('Acesso não autorizado');
      return;
    }
    setDbUserId(userId);
  }, [user]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (dbUserId) {
          const response = await apiLoadUser(dbUserId);
          if (response) {
            setDbUser(response);
            setSelectedName(response.name);
            setSelectedEmail(response.email);
            setSelectedMobile(response.mobile);
            setSelectedState(response.state);
            setSelectedCity(response.city);
            setSelectedSubscription(response.subscription !== null ? response.subscription : '');
            setSelectedReleasedDeadline(subscriptionExpirationDate(response.releasedDeadline));
            setSelectedSearches(response.searches);
          } else {
            addToast('Usuário não encontrado');
          }
        }
      } catch (error) {
        addToast('Erro ao carregar usuário');
      }
    };
    fetchUser();
  }, [dbUserId]);

  const handleBack = () => {
    navigate('/main/settings');
  };

  useEffect(() => {
    if (selectedState) {
      const state = braUfCities.find(uf => uf.sigla === selectedState);
      setCities(state ? state.cidades : []);
    } else {
      setCities([]);
    }
  }, [selectedState]);

  const subscriptionExpirationDate = (releasedDeadline) => {
    if (!releasedDeadline) {
      return '';
    }
    const [year, month, day] = releasedDeadline.split('T')[0].split('-');
    const date = `${year}-${month}-${day}`;
    return date;
  };

  const subscriptionCreated = (date) => {
    if (!date) {
      return '-';
    }
    return new Date(date).toLocaleDateString();
  };

  const subscriptionUpdated = (date) => {
    if (!date) {
      return '-';
    }
    return new Date(date).toLocaleDateString();
  }

  const subscriptionLastLogin = (date) => {
    if (!date) {
      return '-';
    }

    const lastDate = new Date(date).toLocaleDateString();

    const now = new Date();
    const last = new Date(date);
    const diff = last - now;
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

    if (days === 0) {
      return lastDate;
    } else if (days > -30) {
      return <span>{lastDate} <Badge pill bg='info'>{days} d</Badge></span>;
    } else {
      return <span>{lastDate} <Badge pill bg='warning'>{days} d</Badge></span>;
    }
  };

  const handleSubmitUser = async (event) => {
    event.preventDefault();
    try {
      setLoadingUser(true);
      const updatedUser = {
        name: selectedName,
        email: selectedEmail,
        mobile: selectedMobile,
        state: selectedState,
        city: selectedCity,
        subscription: selectedSubscription,
        releasedDeadline: selectedReleasedDeadline,
        searches: selectedSearches,
      };

      const response = await apiUpdateUser(userId, updatedUser);
      if (!response.error) {
        addToast('Usuário salvo com sucesso');
        dbUser.name = selectedName;
        dbUser.email = selectedEmail;
        dbUser.mobile = selectedMobile;
        dbUser.state = selectedState;
        dbUser.city = selectedCity;
        dbUser.subscription = selectedSubscription;
        dbUser.releasedDeadline = selectedReleasedDeadline;
        dbUser.searches = selectedSearches;
      } else {
        addToast('Erro ao salvar usuário');
      }
    } catch (error) {
      addToast('Erro ao salvar usuário');
    } finally {
      setLoadingUser(false);
    }
  };

  const handleSubmitPass = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      addToast('As senhas não coincidem');
      return;
    }
    if (password.length < 6) {
      addToast('A senha deve ter no mínimo 6 caracteres');
      return;
    }
    try {
      setLoadingPass(true);
      const response = await apiUpdatePassword(dbUserId, password);
      if (response) {
        addToast('Senha atualizada com sucesso');
        setPassword('');
        setConfirmPassword('');
      } else {
        addToast('Erro ao atualizar senha');
      }
    } catch (error) {
      addToast('Erro ao atualizar senha');
    } finally {
      setLoadingPass(false);
    }
  };


  return (
    <>
      <Container>
        <Row>
          <Col>
            <PageTitle text='EDITAR CADASTRO' />
          </Col>
        </Row>
      </Container>
      <Container className=''>
        <Row>
          <Col>
            <Button onClick={handleBack}>VOLTAR</Button>
          </Col>
        </Row>
      </Container>
      {dbUser && (
        <Container className='mt-3'>
          <Row>
            {/* Formulário principal */}
            <Col md={8}>
              <Card>
                <Card.Header className="bg-secondary text-white">
                  MEUS DADOS
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={handleSubmitUser}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nome:</Form.Label>
                      <Form.Control
                        type="text"
                        name='name'
                        value={selectedName}
                        onChange={(e) => setSelectedName(e.target.value)}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>E-mail:</Form.Label>
                      <Form.Control
                        type="email"
                        name='email'
                        value={selectedEmail}
                        onChange={(e) => setSelectedEmail(e.target.value)}
                        required
                      />
                    </Form.Group>

                    {/* Telefone */}
                    <Form.Group className="mb-3">
                      <Form.Label>Telefone:</Form.Label>
                      <Form.Control
                        type='text'
                        name='mobile'
                        value={selectedMobile}
                        onChange={(e) => setSelectedMobile(e.target.value)}
                      />
                    </Form.Group>

                    {/* Estado */}
                    <Form.Group className="mb-3">
                      <Form.Label>Estado:</Form.Label>
                      <Form.Select
                        size='sm'
                        name='state'
                        value={selectedState}
                        onChange={(e) => setSelectedState(e.target.value)}
                      >
                        {braUfCities.map((uf, index) => (
                          <option key={uf.sigla} value={uf.sigla}>{uf.sigla + '/' + uf.nome}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {/* Cidade */}
                    <Form.Group className="mb-3">
                      <Form.Label>Cidade:</Form.Label>
                      <Form.Select
                        size='sm'
                        name='city'
                        value={selectedCity}
                        onChange={(e) => setSelectedCity(e.target.value)}
                      >
                        {cities.map((city, index) => (
                          <option key={index} value={city}>{city}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {/* Plano */}
                    <Form.Group className="mb-3">
                      <Form.Label>Plano:</Form.Label>
                      <Form.Select
                        size='sm'
                        name='subscription'
                        value={selectedSubscription}
                        onChange={(e) => setSelectedSubscription(e.target.value)}
                      >
                        <option value=''></option>
                        <option value='0'>Grátis</option>
                        <option value='1'>Mensal</option>
                        <option value='2'>Anual à Vista</option>
                        <option value='3'>Anual Parcelado (Assinatura)</option>
                      </Form.Select>
                    </Form.Group>

                    {/* Vencimento */}
                    <Form.Group className="mb-3">
                      <Form.Label>Vencimento:</Form.Label>
                      <Form.Control
                        type='date'
                        name='releasedDeadline'
                        value={selectedReleasedDeadline}
                        onChange={(e) => setSelectedReleasedDeadline(e.target.value)}
                      />
                    </Form.Group>

                    {/* Pesquisas */}
                    <Form.Group className="mb-3">
                      <Form.Label>Pesquisas:</Form.Label>
                      <Form.Control
                        type='number'
                        name='searches'
                        value={selectedSearches}
                        onChange={(e) => setSelectedSearches(e.target.value)}
                      />
                    </Form.Group>

                    <Button type='submit' variant="primary" size="sm" className='w-100 me-1 w-25' disabled={loadingUser}>
                      {loadingUser ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Salvar'}
                    </Button>

                  </Form>
                </Card.Body>
              </Card>

              <Card className="mt-4">
                <Card.Header className="bg-secondary text-white">
                  ALTERAR SENHA
                </Card.Header>
                <Card.Body>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>Nova senha:</Form.Label>
                      <Form.Control
                        type='password'
                        name='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </Form.Group>

                    {/* Repetir a senha */}
                    <Form.Group className="mb-3">
                      <Form.Label>Repetir a senha:</Form.Label>
                      <Form.Control
                        type='password'
                        name='confirmPassword'
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </Form.Group>

                    {/* Botão salvar */}
                    <Button onClick={handleSubmitPass} variant="primary" size="sm" className='w-100 me-1 w-25' disabled={loadingPass}>
                      {loadingPass ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Salvar'}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className='mt-3'>
                <Card.Header className="bg-secondary text-white">
                  CADASTRADO
                </Card.Header>
                <Card.Body>
                  <h5><i className="bi bi-calendar3"></i> {subscriptionCreated(dbUser.createdAt)}</h5>
                </Card.Body>
              </Card>

              <Card className='mt-3'>
                <Card.Header className="bg-secondary text-white">
                  ATUALIZADO
                </Card.Header>
                <Card.Body>
                  <h5><i className="bi bi-calendar3"></i> {subscriptionUpdated(dbUser.updatedAt)}</h5>
                </Card.Body>
              </Card>

              <Card className='mt-3'>
                <Card.Header className="bg-secondary text-white">
                  ÚLTIMO ACESSO
                </Card.Header>
                <Card.Body>
                  <h5><i className="bi bi-calendar3"></i> {subscriptionLastLogin(dbUser.loginDate)}</h5>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default Profile;